import { InformationCircleIcon } from '@heroicons/react/24/outline'
import Tooltip from '@mui/material/Tooltip'
import { useTranslation } from '../../hooks/useIntractionTranslate'
import { INTERAX_COLORS } from '../../../constants/interaxColors'

interface LocalTimeBadgeProps {
  /** 'scheduling' shows an additional note about participants seeing their own timezone */
  variant?: 'scheduling' | 'display'
  size?: number
}

export const LocalTimeBadge = ({ variant = 'display', size = 14 }: LocalTimeBadgeProps) => {
  const { t } = useTranslation()
  const title = variant === 'scheduling' ? t('common.localTimeBadge.scheduling') : t('common.localTimeBadge.display')

  return (
    <Tooltip title={title} arrow placement="top">
      <InformationCircleIcon
        style={{
          width: size,
          height: size,
          flexShrink: 0,
          cursor: 'help',
          color: INTERAX_COLORS.sun
        }}
        aria-label={title}
      />
    </Tooltip>
  )
}
